import React, {useEffect, useState} from 'react';
import OpsLogo from "../../ops-library/ops-logo";
import OpsBtn from "../../ops-library/ops-btn";
import {useNavigate, useParams} from "react-router-dom";
import {BackgroundImages} from "../../components/AuthBackground";
import AppContainer from "../../components/AppContainer";
import OpsIconOkText from "../../ops-library/ops-icon-ok-text";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import {Form} from "react-bootstrap";
import axios from "axios";
import opsToast from "../../ops-library/ops-toast";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {isTokenExpired} from "../../functions/isTokenExpired";
import {AuthLoadingSpinner} from "../../components/AuthLoadingSpinner";

const RegistrationEmployee = () => {

    const navigate = useNavigate()
    const {uid, domain} = useParams();
    const [processed, setProcessed] = useState(false)
    const [user, setUser] = useState({});
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);

    useEffect(() => {
        if (token && !isTokenExpired(token)) {
            navigate("/")
        } else {
            getEmployee()
        }
    }, []);

    function getEmployee() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/auth/getByUID/${uid}`,
        };
        axios(configuration)
            .then((result) => {
                setUser(result.data.content)
            })
            .catch((error) => {
                navigate("/")
                console.log(error)
            });
    }

    const AccountRegister = () => {
        const [errorPassword, setErrorPassword] = useState(false);
        const [password, setPassword] = useState("");

        function handleRegister(e) {
            e.preventDefault();

            if (password.length < 8) {
                opsToast("Heslo musí obsahovať minimálne 8 znakov!", "error", "colored", true, "top-center")
                setErrorPassword(true)
            } else {
                setProcessed(true)

                const configuration = {
                    method: "patch",
                    url: `${process.env.REACT_APP_API_BASE_URL}/auth/account/verify/${user._id}`,
                    data: {
                        email: user.email,
                        password: password,
                    },
                };

                axios(configuration)
                    .then((result) => {
                        localStorage.setItem(ACCESS_TOKEN_KEY, result.data.token)
                        setProcessed(false)
                        navigate(`/admin`)
                    })
                    .catch((error) => {
                        opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                        setProcessed(false)
                    });
            }

        }

        return (
            <div className="account-tab-container px-2 py-3 rounded-5 shadow-sm">
                <div className="account-tab-content">
                    <div className="fa-flex-col align-items-center mt-4">
                        <OpsLogo size="bg pointer-cursor" action={() => navigate("/")}/>
                        <OpsText type="title" className="mt-4"
                                 content={"Registrácia\npoužívateľov"}/>
                    </div>
                    <Form className="login-form mt-3"
                          onSubmit={(e) => handleRegister(e)}>
                        <OpsInput
                            required
                            disabled
                            id="forename"
                            type="text"
                            label="Meno"
                            labelColor="color-2"
                            className="color-2"
                            value={user.forename}
                        />
                        <OpsInput
                            required
                            disabled
                            id="surname"
                            type="text"
                            label="Priezvisko"
                            labelColor="color-2"
                            className="color-2"
                            value={user.surname}
                        />
                        <OpsInput
                            required
                            disabled
                            id="email"
                            type="email"
                            label="E-mail"
                            labelColor="color-2"
                            className="color-2"
                            value={user.email}
                        />
                        <OpsInput
                            error={errorPassword}
                            required
                            customType="password"
                            id="password"
                            type="password"
                            label="Heslo"
                            labelColor="color-2"
                            placeholder="Zadajte heslo"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value)
                                setErrorPassword(false)
                            }}
                        />

                        <OpsBtn size="md" text="Pokračovať" type="submit"
                                variant="primary w-100 mt-3"
                                action={(e) => handleRegister(e)}/>
                    </Form>
                </div>
            </div>
        );
    }

    return (
        <AppContainer
            showFooter={false}
            showNavbar={false}
            content={
                <div className="window-login-container">
                    <BackgroundImages/>
                    {processed ?
                        <AuthLoadingSpinner/>
                        :
                        <AccountRegister/>
                    }
                </div>
            }
        />
    )

};

export default RegistrationEmployee;